<template>
  <div class="registerb">
    <el-form  label-width="100px" class="demo-ruleForm" >
      <div class="Rtitle">
        <span class="titlel">{{InsName}}</span><span class="titler"> | 用户注册</span>
      </div>
      <div class="rsmin">
            <img src="../assets/images/registersuccess.png" alt="">
            <p>恭喜您,注册成功！</p>
            <!-- <a href="#" id="isgo">正在跳转...</a> -->
      </div>
    </el-form>
  </div>

</template>

<script>

export default {
  name: "registersuccess",
  data() {
    return {
      callbackurl:"",
      InsName: "",
      insCode:""
    };
  },
  mounted(){
         // 判断pc还是app
         var screenWidth = document.body.clientWidth;
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) || screenWidth <= 600) {
        // console.log("这个是H5")
        // this.Source = "APP";
        $(".Rtitle").css("padding-left","0px")
        $(".rsmin p").css("font-size","20px")
        $(".rsmin img").css("width","70%")
      } else {
        // this.Source = "PC";
      }
  },
  created() {
    this.InsName = JSON.parse(sessionStorage.getItem("InsNameCn"));
    this.insCode = this.$route.query.insCode;

     this.callbackurl = sessionStorage.getItem("callbackurl");
     var configCallbackUrl = JSON.parse(sessionStorage.getItem("configCallbackUrl"));
    console.log(configCallbackUrl);
    var _this = this;
     if(this.callbackurl == "" || this.callbackurl == null || this.callbackurl == "undefined"){// 判断注册页url参数是否含有回调地址
        if (configCallbackUrl == "" || configCallbackUrl == null || configCallbackUrl == "undefined") {// 判断配置文件是否配置回调地址
         console.log("停留在本页面")
        } else {
         if (configCallbackUrl == "{insCode}") { // 配置文件中回调地址只有占位符, 跳转至登录页, 携带机构
            console.log("跳转至登录页")
            setTimeout(()=>{
              _this.$router.push("/Login/" + _this.insCode);
            },3000) 
          } else if (configCallbackUrl.indexOf("{insCode}") != -1) { // 包含占位符, 占位符替换为机构, 跳转
            console.log("替换机构占位符, 并跳转")
            configCallbackUrl = configCallbackUrl.replace("{insCode}", this.insCode);
            console.log(configCallbackUrl);
            setTimeout(()=>{
              window.location.href = configCallbackUrl;
            },3000) 
          } else { // 有回调地址, 但不包含占位符, 直接跳转
            console.log("直接跳转");
            setTimeout(()=>{
             window.location.href = configCallbackUrl;
            },3000) 
          }
        }
        return;
     }else{
        // $("#isgo").css("display","block");
        var _this = this;
        setTimeout(()=>{
          window.location.href = _this.callbackurl;
        },3000) 
     }
  },
  methods: {

  }
};
</script>


<style lang="less" scoped>
// #isgo{
//   display: none;
// }
</style>



// WEBPACK FOOTER //
// src/components/registersuccess.vue